import { DtoDynamicTestSet, DtoEntry, DtoTestSet } from "@/types";
import { SolutionJourney, SolutionJourneyItem } from "./types";
import { CubeSideName } from "../../components/Сube/types";

const SCALE_INDEX_TO_COLOR: { [key: number]: string } = {
  0: "var(--fl-color-primary)",
  1: "rgb(85, 125, 225)",
  2: "var(--fl-color-secondary)",
};

export function buildJourneyPhases(
  solutionTestSet: DtoTestSet
): SolutionJourney[] {
  return solutionTestSet.scales.map((scale, i) => {
    const items = solutionTestSet.items
      .filter(item => item.category === scale.category)
      .map<SolutionJourneyItem>(item => {
        return {
          id: item._id,
          label: item.v1,
          secondaryLabel: item.v2,
          description: item.v4,
          descriptionFull:
            "Long AI description...Long AI description...Long AI description...Long AI description...Long AI description...Long AI description...Long AI description...Long AI description...",
        };
      });

    return {
      id: scale._id,
      title: scale.scaleName,
      summary: {
        title: scale.scaleDescription,
        items: items.map(item => ({
          id: item.id,
          label: item.label,
          description: item.description,
        })),
      },
      color: SCALE_INDEX_TO_COLOR[i],
      items,
    };
  });
}

export function buildSolutionCubeSideData(
  entries: DtoEntry[],
  cubeSide: CubeSideName,
  testSet: DtoTestSet | undefined,
  dynamicTestSetsForSide: DtoDynamicTestSet[]
) {
  // Create a Set of dynamic test set IDs for O(1) lookup performance
  const dynamicTestSetIds = new Set(dynamicTestSetsForSide.map(dts => dts._id));

  // Count entries that match dynamic test sets for this side
  const entriesCount = entries.filter(entry =>
    dynamicTestSetIds.has(entry.testSetId)
  ).length;

  return {
    title: testSet?.info?.name || `Side ${cubeSide}`,
    value: entriesCount,
    dynamicTestSetsForSide,
  };
}
